import { useAtom } from "jotai";
import { useTranslation } from "react-i18next";
import { errorOverlayStateAtom } from "reports/components/ErrorOverlay";
import styled from "styled-components/macro";

type ErrorPageProps = {
  error: string | React.JSX.Element;
};

const ErrorPage = ({ error }: ErrorPageProps) => {
  const { t } = useTranslation("ErrorPage");
  const [errorOverlayState] = useAtom(errorOverlayStateAtom);
  return (
    <ErrorPageStyles>
      <h2>{errorOverlayState.overrideDefaultMessage ?? t("error")}</h2>
      {typeof error === "string" ? (
        <div className="errorMsg">
          <pre>
            <code>{error}</code>
          </pre>
        </div>
      ) : (
        <div className="errorMsg">{error}</div>
      )}
    </ErrorPageStyles>
  );
};

export default ErrorPage;

const ErrorPageStyles = styled.div`
  margin: 2em auto;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 0 4em;
  font-family: "Open Sans", sans-serif;
  h2 {
    margin-bottom: 0.5em;
  }
  .errorMsg {
    max-width: calc(100vw - 32px);
    line-height: 1.5em;
  }
  pre {
    white-space: pre-wrap;
    background: #f5f5f5;
    border-radius: 4px;
    padding: 0.5em 1em;
  }
  code {
  }
`;
